export function RichTextResponsiveTable(selector) {
    let init = (table) => {
        if (document.body.classList.contains('neos-backend')) {
            return;
        }

        let tableInner = table.querySelector('table');
        let scrollButtons = document.createElement('DIV');
        if (tableInner.scrollWidth <= tableInner.getBoundingClientRect().width) return;

        let intLabels = JSON.parse(table.closest('.rich-text').dataset.labels);
        scrollButtons.classList.add('container__scroll-buttons');
        scrollButtons.innerHTML = `
            <button class="container__scroll-button container__scroll-button--left" id="scroll-left" aria-label="${intLabels.left}" title="${intLabels.left}"></button>
            <button class="container__scroll-button container__scroll-button--right container__scroll-button--is-available" id="scroll-right" aria-label="${intLabels.right}" title="${intLabels.right}"></button>`;
        let scrollButtonsArray = Array.from(scrollButtons.querySelectorAll('button'));
        let updateScrollButtonOffset = () => {
            // Keep the sticky controls centered in the table's normal position.
            scrollButtons.style.setProperty(
                '--container-scroll-buttons-offset',
                `${tableInner.getBoundingClientRect().height / 2}px`
            );
        };

        table.prepend(scrollButtons);
        updateScrollButtonOffset();
        if ('ResizeObserver' in window) {
            new ResizeObserver(updateScrollButtonOffset).observe(tableInner);
        } else {
            window.addEventListener('resize', updateScrollButtonOffset);
        }
        let buttonLeft = scrollButtons.querySelector('.container__scroll-button--left');
        let buttonRight = scrollButtons.querySelector('.container__scroll-button--right');

        scrollButtonsArray.forEach((element) => {
            element.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();

                let type = 'left';
                if (e.target.classList.contains('container__scroll-button--right')) {
                    type = 'right';
                }

                tableInner.scrollTo({
                    top: 0,
                    left: tableInner.scrollLeft + window.innerWidth * (type === 'left' ? -1 : 1),
                    behavior: 'smooth',
                });
            });
        });

        window.addEventListener(
            'scroll',
            (e) => {
                if (!e.target === tableInner) return;

                //buttons
                let containerRect = tableInner.getBoundingClientRect();
                let isEdgeLeft = tableInner.scrollLeft <= 10;
                let isEdgeRight = tableInner.scrollWidth - tableInner.scrollLeft - containerRect.width <= 10;

                buttonLeft.classList[isEdgeLeft ? 'remove' : 'add']('container__scroll-button--is-available');
                buttonRight.classList[isEdgeRight ? 'remove' : 'add']('container__scroll-button--is-available');
            },
            true
        );
    };

    let initTables = () => {
        let tables = document.querySelectorAll(selector);
        Array.from(tables).forEach((element) => {
            init(element);
        });
    };

    // Table measurements can wait until after the first render.
    if ('requestIdleCallback' in window) {
        requestIdleCallback(initTables, { timeout: 3000 });
    } else {
        window.addEventListener('load', initTables, { once: true });
    }
}
